<!-- ============================================================== -->
<!-- sidebar -->
<!-- ============================================================== -->
<div class="user-profile" style="
    background: url(assets/images/background/user-info-orange.svg) no-repeat;
    background-size: cover;
  ">
  <!-- User profile image -->
  <div class="profile-img" (click)="closeSideNav()">
    <img [src]="
        userService?.UserProfile?.avatar ||
        'assets/images/blank-profile-picture.jpg'
      " alt="user" />
  </div>
  <!-- User profile text-->
  <!-- ============================================================== -->
  <!-- Profile - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div class="profile-text">
    <a [matMenuTriggerFor]="sdprofile" class="">
      {{ userService?.UserProfile?.name }}
      <i class="ti-angle-down font-12 m-l-5"></i>
    </a>
  </div>
  <mat-menu #sdprofile="matMenu" class="mymegamenu">
    <button mat-menu-item routerLink="/others/my-profile" (click)="closeSideNav()">
      <img src="assets/images/icon/profile.svg" style="vertical-align:middle;" class="sidebar-icon"/>
      <span class="subblack">Profile</span>
    </button>

    <button mat-menu-item (click)="authService.logout()">
      <img src="assets/images/icon/px-logout.svg" style="vertical-align:middle;" class="sidebar-icon"/>
      <span class="subblack">Log Out</span>
    </button>
  </mat-menu>
</div>

<mat-nav-list>
  <mat-list-item routerLink="/project-setting/project-list" routerLinkActive="active-page" (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/home.svg" class="sidebar-icon"/>
      <span class="subblack">Home</span>
    </a>
  </mat-list-item>
  <!-- <mat-list-item
    routerLink="/developer-user/user-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon class="lead-icon-color">local_library</mat-icon>
      <span>User</span>
    </a>
  </mat-list-item> -->
  <mat-list-item routerLink="/developer-user/access-security" routerLinkActive="active-page" (click)="closeSideNav()">
    <a class="" *ngIf="superUser">
      <img src="assets/images/icon/access-security.svg" class="sidebar-icon"/>
      <span class="subblack">Access Security</span>
    </a>
  </mat-list-item>

  <!-- <mat-list-item
    routerLink="/team-setting/team-list"
    routerLinkActive="active-page"
    (click)="closeSideNav()"
  >
    <a class="">
      <mat-icon class="lead-icon-color">sports_kabaddi</mat-icon>
      <span>Team</span>
    </a>
  </mat-list-item> -->
  <mat-list-item *ngIf="superUser" routerLink="/company-setting/company-list" routerLinkActive="active-page"
    (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-company.svg" class="sidebar-icon"/>
      <span class="subblack">Company</span>
    </a>
  </mat-list-item>

  <mat-list-item *ngIf="superUser" routerLink="/event/campaign-list" routerLinkActive="active-page"
    (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-campaign.svg" class="sidebar-icon"/>
      <span class="subblack">Campaign</span>
    </a>
  </mat-list-item>

  <mat-list-item
  *ngIf="userService?.PurchaserApp"
    routerLinkActive="active-page"
  >
    <mat-expansion-panel style="box-shadow: none">
      <mat-expansion-panel-header style="padding: 10px">
        <mat-panel-title>
          <div fxLayout="row" fxLayoutAlign="start center">
            <img
              src="assets/images/icon/px-purchaser-user-management.png"
              alt="Purchaser App Icon"
              class="sidebar-icon"
            />
            <span class="subblack">Purchaser App Setting</span>
          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <mat-card
        class="core-list"
        routerLink="/purchaser-app-setting/user-management"
        (click)="closeSideNav()"
      >
        <mat-list fxLayout="row-wrap">
          <mat-list-item fxLayout="row-wrap">
            <img
              src="assets/images/icon/user-management.png"
              class="sidebar-icon"
            />
            <div matLine class="xsTitle-f">User Management</div>
          </mat-list-item>
        </mat-list>
      </mat-card>
      <mat-card
        class="core-list"
        routerLink="/purchaser-app-setting/project-setting"
        (click)="closeSideNav()"
      >
        <mat-list fxLayout="row-wrap">
          <mat-list-item fxLayout="row-wrap">
            <img
              src="assets/images/icon/project-setting.png"
              class="sidebar-icon"
            />
            <div matLine class="xsTitle-f">Project Setting</div>
          </mat-list-item>
        </mat-list>
      </mat-card>
      <mat-card
        class="core-list"
        routerLink="/purchaser-app-setting/parameter-setting"
        (click)="closeSideNav()"
      >
        <mat-list fxLayout="row-wrap">
          <mat-list-item fxLayout="row-wrap">
            <img
              src="assets/images/icon/parameter-setting.png"
              class="sidebar-icon"
            />
            <div matLine class="xsTitle-f">Parameter Setting</div>
          </mat-list-item>
        </mat-list>
      </mat-card>
    </mat-expansion-panel>
  </mat-list-item>
  
  <!-- <mat-list-item *ngIf="superUser" routerLinkActive="active-page" routerLink="/discount/discount-list"
    (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-discount.svg" class="sidebar-icon"/>
      <span class="subblack">Discount</span>
    </a>
  </mat-list-item>
  <mat-list-item *ngIf="superUser" routerLinkActive="active-page" routerLink="/banker-setting/banker-list"
    (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-end-financier.svg" class="sidebar-icon"/>
      <span class="subblack">End Financier</span>
    </a>
  </mat-list-item>

  <mat-list-item *ngIf="superUser" routerLinkActive="active-page" routerLink="/solicitor-setting/solicitor-list"
    (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-solicitor.svg" class="sidebar-icon"/>
      <span class="subblack">Solicitor</span>
    </a>
  </mat-list-item> -->

  <mat-list-item *ngIf="superUser" routerLinkActive="active-page"
    routerLink="/news-announcements/news-announcements-list" (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-file.svg" class="sidebar-icon"/>
      <span class="subblack">Bulletin</span>
    </a>
  </mat-list-item>
  <!-- <mat-list-item routerLinkActive="active-page" routerLink="/payment/payment-list" (click)="closeSideNav()">
    <a class="">
      <mat-icon>payments</mat-icon>
      <span>Payment Gateway</span>
    </a>
  </mat-list-item> -->
  <mat-list-item *ngIf="superUser" routerLinkActive="active-page" routerLink="/general-setting/setting-list"
    (click)="closeSideNav()">
    <a class="">
      <img src="assets/images/icon/px-system_admin.svg" class="sidebar-icon"/>
      <span class="subblack">General Setting</span>
    </a>
  </mat-list-item>

  <!-- <mat-list-item (click)="closeSideNav()">
        <a class="">
            <mat-icon>library_books</mat-icon>
            <span>Agency Setting</span>
        </a>
    </mat-list-item> -->

  <mat-divider></mat-divider>

  <!-- <mat-list-item
    class="m-t-10"
    (click)="closeSideNav()"
    routerLinkActive="selected"
    routerLink="/setting/setting-list"
  >
    <a class="">
      <mat-icon>settings</mat-icon>
      <span>General Setting</span>
    </a>
  </mat-list-item> -->

  <mat-list-item (click)="authService.logout()">
    <a class="" (click)="closeSideNav()">
      <img src="assets/images/icon/px-logout.svg" class="sidebar-icon"/>
      <span class="subblack">Log Out</span>
    </a>
  </mat-list-item>
</mat-nav-list>